<template>
  <v-row justify="center" align="center">
    <v-col cols="auto">
      <equipment-button></equipment-button>
    </v-col>
  </v-row>
</template>

<script>
  import EquipmentButton from "../components/equipment-button"
  export default {
    name: "home-extras",
    components: {EquipmentButton}
  }
</script>

<style scoped>

</style>
